import React, { useEffect, useState } from 'react';
import {
    TextField,
    DialogTitle,
    DialogContentText,
    DialogContent,
    DialogActions,
    Dialog,
    Button,
    Stack
} from '@mui/material';
import { ValidateEmail } from '../../../Utils';
import toast from 'react-simple-toasts';
import { messages } from '../../../messages';
import { updateContact } from '../../../paymentRequest';
import { hideApiLoader, showApiLoader } from '../../../../redux/tool-webjam/actions';
import { useDispatch } from 'react-redux';
import PModalFooter from '../helperComponent/PModalFooter';
import { ct } from '../../../../constant-Utils';


function UpdateContact(props) {
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [formValues, setFormValues] = useState("")

    const { title, handleContactUpdate, id, updateEmail } = props;

    const handleClose = (type) => {
        setOpen(false);
        handleContactUpdate(type)

    };

    useEffect(() => {
        setOpen(true);
        setFormValues(updateEmail)

    }, [])

    let handleInputChange = (e, i) => {
        setFormValues(e.target.value)
    }

    const handleFormSubmit = () => {
        if (!formValues) {
            toast(ct("messages.emailRequired","messages"));
        } else if (!ValidateEmail(formValues)) {
            toast(ct("messages.emailInvalid","messages"));
        } else {
            dispatch(showApiLoader())
            updateContact({
                email: formValues,
                id
            }).then(async res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    let msg = await dynamicMessageLocale(res.data.message);
                    toast(msg)
                    handleContactUpdate(false, 1)
                } else if (res.error == 400 || res.error == 406) {
                    if (res.data?.message) {
                        let msg = await dynamicMessageLocale(res.data.message);
                        toast(msg)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"))
                    }
                }
            })
        }
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <Stack direction="row" spacing={2} className="m-b-20">

                        <TextField
                            label="Email address"
                            variant="filled"
                            name={"email"}
                            onChange={(e) => handleInputChange(e)}
                            value={formValues}
                            className="payment-input"
                            autoComplete="password"
                            sx={{
                                width:"100%"
                            }}
                        />

                    </Stack>
                </DialogContent>
                <PModalFooter
                    submit={() => handleFormSubmit()}
                    cancel={() => handleClose(false)}
                />
            </Dialog>
        </div>
    );
}

export default UpdateContact;
